<template>
    <div class="top-results">
        <div
            v-for="(card, cardKey) in displayedResults"
            :key="cardKey"
            class="top-results__card"
            tabindex="0"
        >
            <div class="top-results__inner">
                <h4 class="top-results__title">
                    <a
                        :href="`/${card.url}`"
                        @click="handleClick('phone_number', $event)"
                        @keypress="handleClick('phone_number', $event)"
                    >
                        {{ card.title }}
                    </a>

                    <span class="top-results__type">
                        {{ getType(card.type) }}
                    </span>
                </h4>

                <template v-if="card.type === 'event'">
                    <p class="top-results__info" v-html="card.excerpt"></p>
                </template>
                <template v-else>
                    <p class="top-results__info">
                        {{ getBody(card) }}
                    </p>
                </template>

            </div>
        </div>

        <button
            class="button top-results__load"
            @click="incrementShown"
            @keypress="incrementShown"
            v-show="shownCount <= allResults.length"
        >
            Load More
        </button>
    </div>
</template>

<script>
import { swiftypeClickMixin } from '../../../scripts/mixins';

const baseData = [];

export default {
    name: 'top_result',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        allResults: {
            type: Array,
            default: () => [],
        },
        name: {
            default: 'Top Results',
        },
    },
    mixins: [swiftypeClickMixin],
    data: () => ({
        shownCount: 20,
    }),
    methods: {
        getType(type) {
            if (type === 'personnel') {
                type = 'provider';
            }

            return type.charAt(0).toUpperCase() + type.slice(1);
        },
        getBody(card) {
            let body = '';

            if (card.type === 'personnel') {
                body = `${card.position}, ${card.primary_location}`
            } else {
                if ('excerpt' in card) {
                    body = card.excerpt;
                } else if ('body' in card) {
                    body = card.body;
                } else if ('bio' in card) {
                    body = card.bio;
                } else if ('location_type' in card) {
                    body = card.location_type
                }

                if (body.length > 120) {
                    return `${body.substring(0, 120)}...`;
                }
            }

            return body;
        },
        incrementShown() {
            this.shownCount += 20;
        }
    },
    filters: {
        capitalize(value) {
            if (!value) {
                return '';
            }

            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
    computed: {
        displayedResults() {
            return this.allResults.slice(0, this.shownCount);
        },
    },
};
</script>

